'use strict';

/**
 * 
 * Form validation - success/error/redirect/or just message
 * jQuery dependency needed
 * HTML: onsubmit="return XXX._form(this);" and loading layer inside form <div class="loading"></div>
 */

var UTILS = UTILS || {};

let validationFormsList = [];

const addToValidationFormsList = (form) => {
    validationFormsList.push(form);
    return validationFormsList;
};

const resetValidationFormsList = () => {
    validationFormsList.forEach(formValidator => formValidator.destroy());
    validationFormsList = [];
    return validationFormsList;
};

const getValidationFormsList = () => {
    return validationFormsList;
};

const initValidation = () => {
    
    let forms = document.querySelectorAll('form');

    let defaultConfig = {
        // class of the parent element where the error/success class is added
        classTo: 'form__group',
        errorClass: 'has-danger',
        successClass: 'has-success',
        // class of the parent element where error text element is appended
        errorTextParent: 'form__group',
        // type of element to create for the error text
        errorTextTag: 'div',
        // class of the error text element
        errorTextClass: 'form__error' 
    };

    [].forEach.call(forms, function(form) {
        let pristine = new Pristine(form, defaultConfig, true);
        addToValidationFormsList(pristine);
    });
};

function trackFormSubmission({
    eventName, 
    eventCategory, 
    eventAction, 
    eventLabel, 
    eventValue
}) {
    if (window['dataLayer'] === undefined) {
        return;
    }

    let data = {
        'event': eventName,
        'event-category': eventCategory,
        'event-action': eventAction,
        'event-label': eventLabel
    }

    if (eventValue) {
        data['event-value'] = eventValue;
    }

    window.dataLayer.push(data);
}

function sendEventTrackingFromForm(form) {
    const eventCategory = form.data('ga-event-category');
    const eventAction = form.data('ga-event-action');
    const eventLabel = form.data('ga-event-label');
    const eventValue = form.data('ga-event-value');

    if (!eventCategory && !eventAction && !eventLabel) {
        return;
    }

    trackFormSubmission({
        eventName: 'form-submission',
        eventCategory, 
        eventAction, 
        eventLabel, 
        eventValue
    });
}

function setGoogleRecaptchaTokenInForm(form, callback) {
    if (!form) {
        return;
    }

    const recaptchaFieldElement = $(form).find('input[name="recaptcha"]');

    if (!recaptchaFieldElement) {
        return;
    }

    grecaptcha
        .execute(googleRecaptchaClientId, {action: 'ajax/sendForm'})
        .then(token => {
            recaptchaFieldElement.val(token);
 
            if (callback) {
                callback();
            }
        });
}

function sendForm(form, url) {
    let data = $(form).serialize();

    $(form).find('button[type="submit"]').text('Sending...');
    $.ajax({
        url: url,
        method: 'POST',
        data: data,
        dataType: 'json'
    })
    .then(function(response) {
        $(form).find('button[type="submit"]').text('Submit');
        $(form).find('.loading').fadeOut();
        
        sendEventTrackingFromForm($(form));

        if (response.url) {
            window.location.href = response.url;
        } else {
            $(form).find('.loading').fadeOut();

            if ( $(form).find('.response--success').length === 0 ) {
                $(form).prepend( '<div class="response response--success"><p>'+response.message+'</p></div>' );
            } else {
                $('.response--success p').html(response.message);
            }
        }

        // remove error response if exists and reset the form
        $(form).find('.response--error').remove();
        $(form)[0].reset();

    }, function(response) {
        let errorMessage = '';

        if (response.status == 422) {
            for (var field in response.responseJSON) {
                if (response.responseJSON.hasOwnProperty(field)) {
                    errorMessage += response.responseJSON[ field ].join('<br>') + '<br>';
                }
            }
        } else if (response.status == 404) {
            errorMessage = 'Page not found - incorrect url.';
        } else if (response.responseJSON.message) {
            errorMessage = response.responseJSON.message;
        }

        if (errorMessage) {
            if ( $(form).find('.response--error').length === 0 ) {
                $(form).prepend( '<div class="response response--error"><p>'+errorMessage+'</p></div>' );
            } else {
                $('.response--error p').html(errorMessage);
            }
        }

        // remove success response if exists
        $(form).find('.response--success').remove();

        $(form).find('button[type="submit"]').text('Submit');
        $(form).find('.loading').fadeOut();
    });
}

UTILS.initValidation = initValidation;

UTILS.form = function form(form, url) {
    if (!form && !url) {
        console.error('Form or/and form URI not specified.')
        return false;
    }

    let formWithValidation = getValidationFormsList().find(validForm => validForm.form === form);
    let isValid = formWithValidation.validate(); // returns true or false

    if (!isValid) {
        return false;
    }

    $(form).find('.loading').fadeIn();

    if (grecaptcha && googleRecaptchaClientId) {
        setGoogleRecaptchaTokenInForm(form, () => {
            sendForm(form, url);
        });
    } else {
        sendForm(form, url);
    }

    return false;
};
